import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import { CodeEditor as Component } from './CodeEditor';

export const CodeEditor = AsControl()(Component);
export const CodeEditorControl = bindControlToForm()(CodeEditor);
